<template>
  <div id="wrap">
    <div id="chart-benefits">
      <apexchart type="bar" height="350" :options="benefitsChartOptions" :series="series"></apexchart>
    </div>
    <transition name="slide-y">
      <div v-show="showTeamsChart" id="chart-teams">
        <apexchart ref="barTeams" type="bar" height="350" :options="teamsChartOptions" :series="teamSeries"></apexchart>
      </div>
    </transition>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {scale} from "@/utils/colors";

export default {
  name: "SavingsBySavingsType",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    benefits: {
      type: Array,
      default: () => ([])
    },
    currencyFormatter: {
      default: null
    }
  },
  data: () => ({
    dataColor: scale(2, 0.4),
    showTeamsChart: false
  }),
  methods: {
    benefitBarClicked (e, chart, opts) {
      // const teamsChartEl = document.querySelector("#chart-teams");
      // const benefitsChartEl = document.querySelector("#chart-benefits");

      const barSelected = !!opts.selectedDataPoints.find(el => !!el).length;

      if (barSelected) {
        this.updateTeamsChart(chart);
        // if (!teamsChartEl.classList.contains("active")) {
        //   benefitsChartEl.classList.add("chart-teams-activated")
        //   teamsChartEl.classList.add("active");
        // }
        this.showTeamsChart = true;
      } else {
        this.showTeamsChart = false;
        // benefitsChartEl.classList.remove("chart-teams-activated")
        // teamsChartEl.classList.remove("active");
        this.updateTeamsChart(chart);
      }
  },
    updateTeamsChart(sourceChart) {
      let series = [];
      let colors = scale(8, 0.4)

      let seriesIndex = sourceChart.w.globals.selectedDataPoints.findIndex((val) => !!val);
      if (!(seriesIndex >= 0)) return;

      let selectedSeries = sourceChart.w.config.series[seriesIndex]
      if (!selectedSeries) return;

      let selectedIndex = sourceChart.w.globals.selectedDataPoints[seriesIndex][0];
      if (!(selectedIndex >= 0)) return;

      const {teams} = selectedSeries.data[selectedIndex];


      for (let key in teams){
        const {subCategories} = teams[key];
        for (let subCatKey in subCategories) {
          let amount = subCategories[subCatKey];
          series.push({
            name: subCatKey,
            data: Object.keys(teams).map(val => ({
              x: val,
              y: val === key ? amount : 0
            }))
          })
        }
      }

      // if (sourceChart.w.globals.selectedDataPoints[0]) {
      //   let selectedPoints = sourceChart.w.globals.selectedDataPoints;
      //   for (let i = 0; i < selectedPoints[seriesIndex].length; i++) {
      //     let selectedIndex = selectedPoints[seriesIndex][i];
      //     let yearSeries = sourceChart.w.config.series[seriesIndex];
      //     series.push({
      //       name: yearSeries.data[selectedIndex].x,
      //       data: yearSeries.data[selectedIndex].quarters
      //     })
      //     colors.push(yearSeries.data[selectedIndex].color)
      //   }
      //
      //
      //   if (series.length === 0) series = [{
      //     data: []
      //   }]
      //
      // }
      this.$refs.barTeams.chart.updateOptions({colors})
        this.$refs.barTeams.chart.updateSeries(series)
    }
  },
  computed: {
    benefitsBySavingsType() {
      return this.benefits.reduce((obj, benefit) => {
        if (!obj[benefit.savingsType]) {
          obj[benefit.savingsType] = {forecasted: 0, realised: 0}
        }
        obj[benefit.savingsType].forecasted += Number(benefit.forecastedAmountOrgCurrency || 0);
        obj[benefit.savingsType].realised += Number(benefit.amountOrgCurrency || 0);
        return obj;
      }, {})
    },
    benefitsChartOptions() {
      return {
        chart: {
          id: 'barBenefits',
          export: {
            csv: {
              headerCategory: 'Savings Types',
            }
          },
          events: {
            dataPointSelection: this.benefitBarClicked,
            updated:  this.updateTeamsChart,
            mounted: function(chartContext, config) {
              // Select the bar elements and apply the cursor style
              const bars = chartContext.el.querySelectorAll('.apexcharts-series');
              bars.forEach(function(bar) {
                bar.style.cursor = 'pointer';
              });
            }
          }
        },
        title: {
          text: 'Savings by Savings Type',
          align: 'center',
          floating: true
        },
        subtitle: {
          text: '(Click on bar to see savings by Teams)',
          align: 'center',
          offsetY: 22
        },
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        noData: {
          text: 'No Data To Show Yet',
        },
        legend: {
          show: true,
        },
        colors: this.dataColor,
        states: {
          hover: {
            filter: {
              type: 'lighten',
              value: 0.05
            }
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'darken',
              value: 0.35,
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return this.currencyFormatter ? this.currencyFormatter(val) : val;
            }
          }
        },
        xaxis: {
          labels: {
            formatter: (val) => {
              return this.currencyFormatter ? this.currencyFormatter(val) : val;
            },
          }
        },
      }
    },
    series() {
      return [
        {
          name: 'Forecasted',
          data: Object.keys(this.seriesBeta).sort().map(key => {
            return {
              y: this.seriesBeta[key].forecasted.total,
              x: key,
              teams: this.seriesBeta[key].forecasted.teams
            }
          })
        },
        {
        name: 'Realised',
        data: Object.keys(this.seriesBeta).sort().map(key => {
          return {
            y: this.seriesBeta[key].realised.total,
            x: key,
            teams: this.seriesBeta[key].realised.teams
          }
        })
      }]
    },
    benefitsByCategory(){
      return this.benefits.reduce((teams, benefit) => {
        const rootCategory = benefit.rootCategory || 'Uncategorised';
        const subCategory = benefit.category === benefit.rootCategory
          ? (rootCategory ? rootCategory + ' (Uncategorised)' : 'Uncategorised') : (benefit.category || 'Uncategorised')
        if(!teams[rootCategory]){
          teams[rootCategory] = {}
        }
        if(!teams[rootCategory][subCategory]){
          teams[rootCategory][subCategory] = {count: 0}
        }
        teams[rootCategory][subCategory].count++;
        return teams;
      }, {});
    },
    treemapSeries(){
      return Object.keys(this.benefitsByCategory).map(team => ({
        name: team,
        data: Object.keys(this.benefitsByCategory[team]).map(subCategory => ({
          x: subCategory,
          y: this.benefitsByCategory[team][subCategory].count
        }))
      }))
    },
    treemapChartOptions() {
      return {
        legend: {
          show: true
        },
        chart: {
          height: 350,
            type: 'treemap'
        },
        title: {
          text: 'Amount of Savings by Team',
            align: 'center'
        },
        dataLabels: {
          style: {
            colors: ['black']
          },
        }
        // colors: scale(Object.keys(this.benefitsByCategory).length)
      }
    },
    teamSeries() {
      return [{
        data: []
      }]
    },
    teamsChartOptions() {
      return {
        chart: {
          id: 'barTeams',
          stacked: true,
          // stackType: '100%'
        },
        title: {
          text: 'Savings by Team',
          align: 'center',
          floating: true
        },
        noData: {
          text: 'No Data To Show Yet',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            horizontal: true
          }
        },
        legend: {
          show: false
        },
        yaxis: {
          labels: {
            show: true
          }
        },
        dataLabels: {
          formatter: function (val, opt) {
            return opt.w.config.series[opt.seriesIndex].name;
          },
          // textAnchor: 'start',
          // offsetX: 10,
          // style: {
          //   colors: ['black']
          // },
        },
        states: {
          hover: {
            filter: {
              type: 'lighten',
              value: 0.05
            }
          },
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return this.currencyFormatter ? this.currencyFormatter(val) : val;
            }
          }
        },
        xaxis: {
          labels: {
            formatter: (val) => {
              return this.currencyFormatter ? this.currencyFormatter(val) : val;
            },
          }
        },
      }
    },
    seriesBeta() {
      const addBenefit = (obj, benefit, amount) => {
        obj.total += amount;
        const rootCategory = benefit.rootCategory || 'Uncategorised';
        const subCategory = (benefit.category === benefit.rootCategory) ? 'Uncategorised' : benefit.category;

        if(!obj.teams[rootCategory]) {
          obj.teams[rootCategory] = {total: 0, subCategories: {}}
        }
        const team = obj.teams[rootCategory];
        team.total += amount;

        if(!team.subCategories[subCategory]) {
          team.subCategories[subCategory] = 0;
        }
        team.subCategories[subCategory] += amount;
      }


      return this.benefits.reduce((savingsType, benefit) => {
        if (!savingsType[benefit.savingsType]) {
          savingsType[benefit.savingsType] = {
            realised: {total: 0, teams: {}}, forecasted: {total: 0, teams: {}}
          }
        }

        let {realised, forecasted} = savingsType[benefit.savingsType];

        addBenefit(realised, benefit, Number(benefit.amountOrgCurrency || 0));
        addBenefit(forecasted, benefit, Number(benefit.forecastedAmountOrgCurrency))

        return savingsType;
      }, {})
    }
  }
}
</script>

<style lang="scss" scoped>
/*#wrap {*/
/*  margin: 45px auto;*/
/*  max-width: 800px;*/
/*  position: relative;*/
/*}*/

/*.chart-box {*/
/*  padding-left: 0;*/
/*}*/

/*#chart-benefits,*/
/*#chart-teams {*/
/*  width: 96%;*/
/*  max-width: 48%;*/
/*  box-shadow: none;*/
/*  padding-left: 0;*/
/*  padding-top: 20px;*/
/*  background: #fff;*/
/*  border: 1px solid #ddd;*/
/*}*/

/*#chart-benefits {*/
/*  float: left;*/
/*  position: relative;*/
/*  transition: 1s ease transform;*/
/*  z-index: 3;*/
/*}*/

/*#chart-benefits.chart-teams-activated {*/
/*  transform: translateX(0);*/
/*  transition: 1s ease transform;*/
/*}*/

/*#chart-teams {*/
/*  float: left;*/
/*  position: relative;*/
/*  z-index: -2;*/
/*  transition: 1s ease transform;*/
/*}*/

/*#chart-teams.active {*/
/*  transition: 1.1s ease-in-out transform;*/
/*  transform: translateX(0);*/
/*  z-index: 1;*/
/*}*/


.slide-y-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.slide-y-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.slide-y-enter-to, .slide-y-leave {
  max-height: 350px;
  overflow: hidden;
}

.slide-y-enter, .slide-y-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
